module.exports = __webpack_public_path__ + "assets/img/图标／68px@2x.a2dd09e4.png";